// alterado - revisado

const videoList = [
    {
        id: '010.010.010',
        descricao: 'Acesso ao site',
        url: 'https://www.youtube.com/watch?v=w8YUcmr4KQI',
        idCasoNegocio: '010.010',
        ordem: '010.010.010',
    },
    {
        id: '010.010.020',
        descricao: 'Reset de senha',
        url: 'https://www.youtube.com/watch?v=wQOSh7gx9E8',
        idCasoNegocio: '010.010',
        ordem: '010.010.020',
    },
    {
        id: '100.010.010',
        descricao: 'Configurações de Usuários',
        url: 'https://www.youtube.com/watch?v=FLNw4xGoj1A',
        idCasoNegocio: '100.010',
        ordem: '100.010.010'
    },
    {
        id: '100.010.020',
        descricao: 'Criação de Funis de Atendimento',
        url: 'https://www.youtube.com/watch?v=M30wBXu4D-Y',
        idCasoNegocio: '100.010',
        ordem: '100.010.020',
    },
    {
        id: '180.010.010',
        descricao: 'Criando 2 opções de cenário padrão',
        url: 'https://www.youtube.com/embed/TpzDo1zX-9M?si=OBgHEGWl_XqfZyF_',
        idCasoNegocio: '180.010',
        ordem: '180.010.010',
    },
    {
        id: '200.010.010',
        descricao: 'Criando páginas padrão para todos os clientes',
        //url: 'https://www.youtube.com/embed/xheiQC6_0zg?si=9i6dGsOTtxYG3L1j%22',
        url: 'https://www.youtube.com/embed/aOSIeeLY4Ko?si=udh0KHVNxt7g-RQr',
        idCasoNegocio: '200.010',
        ordem: '200.010.010',
    },
    /*{ //Este vídeo foi removido por violar os Termos de Utilização do YouTube
        id: '500.010.010',
        descricao: 'Cadastro de um Novo Cliente',
        url: 'https://www.youtube.com/watch?v=NtMxo9gUWEM',
        idCasoNegocio: '500.010',
        ordem: '500.010.010',
    },*/
    {
        id: '500.010.020',
        descricao: 'Preenchimento de Riscos',
        url: 'https://www.youtube.com/watch?v=l4PCqVew5mI',
        idCasoNegocio: '500.010',
        ordem: '500.010.020',
    },
    {
        id: '500.010.030',
        descricao: 'Preenchimento de Receitas',
        url: 'https://www.youtube.com/watch?v=DB0s51U7eNk',
        idCasoNegocio: '500.010',
        ordem: '500.010.030',
    },
    {
        id: '500.010.040',
        descricao: 'Preenchimento de Despesas',
        url: 'https://www.youtube.com/watch?v=OLF3omakS5Y',
        idCasoNegocio: '500.010',
        ordem: '500.010.040',
    },
    {
        id: '500.010.050',
        descricao: 'Estudo dos Dados',
        url: 'https://www.youtube.com/watch?v=EK_1PBzSICA',
        idCasoNegocio: '500.010',
        ordem: '500.010.050',
    },
    {
        id: '500.020.010',
        descricao: 'Qual a diferença entre o Simplificado e o Completo?',
        url: 'https://www.youtube.com/embed/ZonLY60hJe4?si=Jv3Jlq6b4w8j6UgF%22',
        idCasoNegocio: '500.020',
        ordem: '500.020.010',
    },
    {
        id: '500.030.010',
        descricao: 'Localizando as Apólices de Seguro de Vida',
        url: 'https://www.youtube.com/embed/vTJe5h130vU?si=639HU0FFmWxQ82ie%22',
        idCasoNegocio: '500.030',
        ordem: '500.030.010',
    },
    {
        id: '500.040.010',
        descricao: 'Aula 1: Apresentação',
        url: 'https://www.youtube.com/embed/_-wZnNtwj4Y?si=AWlkE21CwaA996r5',
        idCasoNegocio: '500.040',
        ordem: '500.040.010',
    },
    {
        id: '500.040.020',
        descricao: 'Aula 2: Analisando o PGBL e o VGBL',
        url: 'https://www.youtube.com/embed/qdF1AE9eVbY?si=v8Aa7U1eKlJpDWcF',
        idCasoNegocio: '500.040',
        ordem: '500.040.020',
    },
    {
        id: '500.040.030',
        descricao: 'Aula 3: Completa ou Simplificada?',
        url: 'https://www.youtube.com/embed/Zg6cF-xNsL4?si=5Ti4-W83oCaZ9Rdm',
        idCasoNegocio: '500.040',
        ordem: '500.040.030',
    },
    {
        id: '500.040.040',
        descricao: 'Aula 4: Identificando as despesas dedutíveis',
        url: 'https://www.youtube.com/embed/qk1TSqGpW1Q?si=BlQFxhnTPnL592Hj',
        idCasoNegocio: '500.040',
        ordem: '500.040.040',
    },
    {
        id: '500.040.050',
        descricao: 'Aula 5: Transportando um caso para dentro da Fin-Tracks',
        url: 'https://www.youtube.com/embed/2pFUgg9A8TY?si=P8K4s_XHQFMTbq9b',
        idCasoNegocio: '500.040',
        ordem: '500.040.050',
    },
    {
        id: '500.040.060',
        descricao: 'Aula 6: Aprofundando com exemplos na Fin-Tracks (Parte 1)',
        url: 'https://www.youtube.com/embed/yAxlosokUro?si=tdYMgrYOYdpd57zK',
        idCasoNegocio: '500.040',
        ordem: '500.040.060',
    },
    {
        id: '500.040.070',
        descricao: 'Aula 7: Aprofundando com exemplos na Fin-Tracks (Parte 2)',
        url: 'https://www.youtube.com/embed/LwovjSxRwSQ?si=tlvmIirIwke-c9To',
        idCasoNegocio: '500.040',
        ordem: '500.040.070',
    },
    {
        id: '505.010.010',
        descricao: 'Enviando o link de acesso ao sistema para o cliente',
        url: 'https://www.youtube.com/embed/IRPALDagS0k?si=-FffyXMWcrkhl0lH',
        idCasoNegocio: '505.010',
        ordem: '505.010.010',
    },
    {
        id: '510.010.010',
        descricao: 'Enviando o link de acesso ao sistema para o cliente',
        url: 'https://www.youtube.com/embed/IRPALDagS0k?si=-FffyXMWcrkhl0lH',
        idCasoNegocio: '510.010',
        ordem: '510.010.010',
    },
    {
        id: '520.010.010',
        descricao: '1 - Preenchendo os Dados para Realizar a Simulação Financeira',
        url: 'https://www.youtube.com/embed/1_SpkAxXESc?si=emGJe5mCj40agu2j',
        idCasoNegocio: '520.010',
        ordem: '520.010.010',
    },
    {
        id: '520.010.020',
        descricao: '2 - Analisando as Estratégias Possíveis',
        url: 'https://www.youtube.com/embed/s6fqSde2yPA?si=vzkx5xKsLMhfZMze',
        idCasoNegocio: '520.010',
        ordem: '520.010.020',
    },
    {
        id: '520.010.030',
        descricao: '3 - Aumentando a Rentabilidade e Mostrando outra Estratégia',
        url: 'https://www.youtube.com/embed/vlnxzz7Degk?si=-44GP9LveCodgnrx',
        idCasoNegocio: '520.010',
        ordem: '520.010.030',
    },
    {
        id: '520.010.040',
        descricao: '4 - Entendendo o Poder da Comparação de Cenários',
        url: 'https://www.youtube.com/embed/QZ896IkoiEg?si=7qxIWoHjyrC5Rxji',
        idCasoNegocio: '520.010',
        ordem: '520.010.040',
    },
    {
        id: '520.010.050',
        descricao: '5 - Se o cliente é jovem e pode aporter pouco atualmente, como planejar o aumento dos aportes ao longo do tempo',
        url: 'https://www.youtube.com/embed/gKODqn5CKvE?si=-Srk_pibhzCYsOcF',
        idCasoNegocio: '520.010',
        ordem: '520.010.050',
    },
    {
        id: '520.010.060',
        descricao: '6 - Recebendo uma herança e fazendo aportes únicos',
        url: 'https://www.youtube.com/embed/kRiBBaTPYvw?si=Wf9bwbK-G-xbX0MV',
        idCasoNegocio: '520.010',
        ordem: '520.010.060',
    },
    {
        id: '520.010.070',
        descricao: '7 - Gerando valor na entrega do primeiro relatório',
        url: 'https://www.youtube.com/embed/RnvDtUNBi-4?si=Ix0C3VrE0ZbzM7ae',
        idCasoNegocio: '520.010',
        ordem: '520.010.070',
    },
    {
        id: '520.020.010',
        descricao: 'Criando 2 opções de cenário padrão',
        url: 'https://www.youtube.com/embed/TpzDo1zX-9M?si=OBgHEGWl_XqfZyF_',
        idCasoNegocio: '520.020',
        ordem: '520.020.010',
    },
    {
        id: '520.030.010',
        descricao: 'Diferença entre aportes na Simulação Finaceira e no Estudo',
        url: 'https://www.youtube.com/embed/WvjXfU2-oXs?si=leMyvuv_J1226UHO%22',
        idCasoNegocio: '520.030',
        ordem: '520.030.010',
    },
    {
        id: '574.010.010',
        descricao: 'Entendendo as informações da análise patrimonial',
        url: 'https://www.youtube.com/embed/CX7f7lHTZbI?si=oeDY3IcPtmsdGbPF%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.010',
    },
    {
        id: '574.010.020',
        descricao: 'Analisando as Receitas ao longo do tempo',
        url: 'https://www.youtube.com/embed/0ZSJTJFUrP4?si=G3hWDVprnpifekbs%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.020',
    },
    {
        id: '574.010.030',
        descricao: 'Analisando as Despesas ao longo do tempo',
        url: 'https://www.youtube.com/embed/WJk5aM77qrQ?si=gdq3DgHrKXScgxZq%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.030',
    },
    {
        id: '574.010.040',
        descricao: 'Analisando a Capacidade de Poupança do cliente',
        url: 'https://www.youtube.com/embed/tS-PHiv-KxA?si=6Ivn-4icX2DmlYhS%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.040',
    },
    {
        id: '574.010.050',
        descricao: 'Analisando o Consumo dos recursos financeiros',
        url: 'https://www.youtube.com/embed/5BDp8g39Izc?si=Jn4k4UPGuxZiiF_3%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.050',
    },
    {
        id: '574.010.060',
        descricao: 'Fazendo o primeiro Diagnóstico de Aposentadoria',
        url: 'https://www.youtube.com/embed/GVlt_0zrqc4?si=b-a5NWIsANWBF1HI%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.060',
    },
    {
        id: '574.010.070',
        descricao: 'Diagnóstico de Aposentadoria com uma rentabilidade maior',
        url: 'https://www.youtube.com/embed/LhlXEo05CAs?si=MK45V4DwVLbTy7Zs%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.070',
    },
    {
        id: '574.010.080',
        descricao: 'Obtendo um Diagnóstico mais profundo (parte 1)',
        url: 'https://www.youtube.com/embed/tw_ViGnHdUk?si=hc0Sw2NRYJm_hBrP%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.080',
    },
    {
        id: '574.010.090',
        descricao: 'Obtendo um Diagnóstico mais profundo (parte 2)',
        url: 'https://www.youtube.com/embed/C8OAStdBOwI?si=W44joAHceBqe07gT%22',
        idCasoNegocio: '574.010',
        ordem: '574.010.090',
    },
    {
        id: '574.020.010',
        descricao: 'Diferença entre aportes na Simulação Finaceira e no Estudo',
        url: 'https://www.youtube.com/embed/WvjXfU2-oXs?si=leMyvuv_J1226UHO%22',
        idCasoNegocio: '574.020',
        ordem: '574.020.010',
    },
    {
        id: '576.010.010',
        descricao: 'Veja como utilizar a Análise da Previdência Privada',
        url: 'https://www.youtube.com/embed/YtXrZ0t8yzE?si=qU0VDm_MCTF_RqUI',
        idCasoNegocio: '576.010',
        ordem: '576.010.010',
    },
    {
        id: '578.010.010',
        descricao: 'Criando páginas para um cliente específico',
        url: 'https://www.youtube.com/embed/q65nZU27S9U?si=hRiqkM6roLBHfIxt',
        idCasoNegocio: '578.010',
        ordem: '578.010.010',
    },
    {
        id: '578.020.010',
        descricao: 'Usando o Modo Apresentação',
        url: 'https://www.youtube.com/embed/aJcmDMTzMeU?si=X-b0pC5fO7jzG_TY',
        idCasoNegocio: '578.020',
        ordem: '578.020.010',
    },
]

export default videoList